import { lazyWithRetry } from 'common/utils';

export * from './routes';

export const NatalieListPage = lazyWithRetry(() => import('./NatalieList'));

export const NatalieWizardPage = lazyWithRetry(() => import('./NatalieWizard'));

export const NatalieForParticipantPage = lazyWithRetry(() => import('./NatalieForParticipant'));

export const NatalieEventDetailsPage = lazyWithRetry(() => import('./NatalieEventDetails'));
